import type { DynamicIslandActivity } from '../../context/dynamicIslandTypes'

export type ActivitySoloPresentation = {
  sourceLabel: string
  lifecycle: DynamicIslandActivity['lifecycle']
  accent: DynamicIslandActivity['expanded']['accent']
  title: string
  subtitle: string
  statusLabel?: string
  progressPercent?: number
  showProgress: boolean
}

/** 单来源收起态：从 activity.compact 提取展示字段（与多来源大类卡分离） */
export function getActivitySoloPresentation(activity: DynamicIslandActivity): ActivitySoloPresentation {
  const { compact, sourceLabel, lifecycle } = activity

  if (compact.mode === 'terminal') {
    return {
      sourceLabel,
      lifecycle,
      accent: compact.accent,
      title: compact.title,
      subtitle: compact.hint ?? '',
      showProgress: false,
    }
  }

  if (compact.mode === 'count') {
    const unit = compact.unit ? ` ${compact.unit}` : ''
    return {
      sourceLabel,
      lifecycle,
      accent: compact.accent,
      title: compact.title,
      subtitle: compact.subtitle || `${compact.done}/${compact.total}${unit}`,
      statusLabel: compact.statusLabel,
      progressPercent: compact.progressPercent,
      showProgress: lifecycle === 'active',
    }
  }

  if (compact.mode === 'step') {
    return {
      sourceLabel,
      lifecycle,
      accent: compact.accent,
      title: compact.title,
      subtitle: compact.subtitle || compact.stepLabel,
      statusLabel: compact.statusLabel,
      progressPercent: compact.progressPercent,
      showProgress: lifecycle === 'active',
    }
  }

  return {
    sourceLabel,
    lifecycle,
    accent: compact.accent,
    title: compact.title,
    subtitle: compact.subtitle,
    statusLabel: compact.statusLabel,
    progressPercent: compact.progressPercent,
    showProgress: lifecycle === 'active',
  }
}
